// import { fetchData } from '../../modules/fetchData.js';
import { renderEvents } from '../../modules/renderEvents.js';
import { createEventPagination  } from '../../modules/eventPagination.js';

import events from '../JSON/sonderveranstaltungen/vergangen.json';

// const path = '../JSON/sonderveranstaltungen/vergangen.json';
// let data = [];

const movieContainer = document.querySelector(".movie-container");
const pagination = document.querySelector('.pagination-wrapper');

let currentPage = 1;
const maxDisplayLimit = 25;

// async function getFetchedData() {
//     let data = await fetchData(path);;
//     return data;
// }

// data.push(await getFetchedData());

// let events = data[0];

movieContainer.appendChild(renderEvents(events));
pagination.appendChild(createEventPagination(events, currentPage));